import { ENV } from "@/constants/env";

export const DevIndicator = () => {
    const authDev = ENV.AUTH_SVC_URL.includes("dev");
    const treatmentDev = ENV.TREATMENT_SVC_URL.includes("dev");

    return (
        <div className="fixed bottom-28 -right-19.5 z-maximum flex gap-1 -rotate-90 opacity-60 pointer-events-none">
            {authDev && (
                <div className="text-xs bg-red-600 text-white rounded-tr-sm rounded-tl-sm flex items-center justify-center shadow-md px-2">
                    &lt; Auth /&gt;
                </div>
            )}
            {treatmentDev && (
                <div className="text-xs bg-red-600 text-white rounded-tr-sm rounded-tl-sm flex items-center justify-center shadow-md px-2">
                    &lt; Treatment /&gt;
                </div>
            )}
        </div>
    );
};
